// extracted by mini-css-extract-plugin
export var box = "_8g-1";
export var checkboxRow = "_8g-8";
export var checked = "_8g-2";
export var descriptionSpacer = "_8g-a";
export var disabled = "_8g-3";
export var icon = "_8g-6";
export var input = "_8g-0";
export var labelSpacer = "_8g-9";
export var medium = "_8g-5";
export var small = "_8g-4";
export var text = "_8g-7";